'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dList$002dEnvelopes$002dPage$0024 from "./presto.-List-Envelopes-Page$.js";
import * as $j_presto$002e$002dPresto$002dRouter$0024$0024anon$0024103 from "./presto.-Presto-Router$$anon$103.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$102() {
  this.bci = null;
  this.bca = null;
  this.bcb = false;
  this.bcj = null;
  this.bck = false;
  this.bcn = null;
  this.bcg = null;
  this.bch = false;
  this.bcc = null;
  this.bcd = false;
  this.bce = null;
  this.bcf = false;
  this.bcl = false;
  this.bcm = false;
  this.bci = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bcn = "ListEnvelopesPage";
}
export { $c_Lpresto_PrestoRouter$$anon$102 as $c_Lpresto_PrestoRouter$$anon$102 };
$p = $c_Lpresto_PrestoRouter$$anon$102.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$102;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$102() {
}
export { $h_Lpresto_PrestoRouter$$anon$102 as $h_Lpresto_PrestoRouter$$anon$102 };
$h_Lpresto_PrestoRouter$$anon$102.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.bci;
});
$p.M = (function() {
  if ((!this.bcb)) {
    this.bca = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bcb = true;
  }
  return this.bca;
});
$p.O = (function() {
  if ((!this.bck)) {
    this.bcj = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bck = true;
  }
  return this.bcj;
});
$p.E = (function() {
  return this.bcn;
});
$p.t = (function() {
  if ((!this.bch)) {
    this.bcg = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bch = true;
  }
  return this.bcg;
});
$p.N = (function() {
  if ((!this.bcd)) {
    this.bcc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bcd = true;
  }
  return this.bcc;
});
$p.Q = (function() {
  if ((!this.bcf)) {
    this.bce = new $j_presto$002e$002dPresto$002dRouter$0024$0024anon$0024103.$c_Lpresto_PrestoRouter$$anon$103();
    this.bcf = true;
  }
  return this.bce;
});
$p.v = (function() {
  if ((!this.bcm)) {
    this.bcl = false;
    this.bcm = true;
  }
  return this.bcl;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee618) => ((p) => \u03b4scrutinee618))($j_presto$002e$002dList$002dEnvelopes$002dPage$0024.$m_Lpresto_ListEnvelopesPage$())));
});
var $d_Lpresto_PrestoRouter$$anon$102 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$102, "presto.PrestoRouter$$anon$102", ({
  Nz: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$102 as $d_Lpresto_PrestoRouter$$anon$102 };
//# sourceMappingURL=presto.-Presto-Router$$anon$102.js.map
